export default __webpack_public_path__ + "static/media/owl-logo.4747024a.svg";